import PageWrp from './PageWrp';

export default PageWrp;
